import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { Alert, Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { StoreDetailsRoot, Hooks } from '@grandvisionhq/stores-v2';

const StoreDetailModal = ({ globalStoreId , onModalClose  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const { useStoreDetailsWithGlobalStoreId  } = Hooks;
    const [storeDetailsQuery, storeDetailsQueryState] = useStoreDetailsWithGlobalStoreId();
    const urls = React.useRef({});
    React.useEffect(()=>{
        storeDetailsQuery(globalStoreId);
    }, [
        globalStoreId,
        storeDetailsQuery
    ]);
    const loading = !storeDetailsQueryState.called || storeDetailsQueryState.loading;
    if (storeDetailsQueryState.error) {
        return /*#__PURE__*/ React.createElement(Alert, {
            variant: "info",
            className: "alert-m-default"
        }, getFormattedLabel('common.error.network'));
    }
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: true,
        showIcon: true,
        className: "store-modal",
        onModalClose: onModalClose
    }, loading && /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    }), storeDetailsQueryState.data && /*#__PURE__*/ React.createElement(StoreDetailsRoot, {
        store: storeDetailsQueryState.data,
        hidePhone: false,
        hideEmail: false,
        urls: urls.current
    }));
};

export { StoreDetailModal as default };
//# sourceMappingURL=StoreDetailModal.js.map
